import React from 'react';
import { Provider } from 'react-redux';

import Base from './Base.jsx';

import Dashboard from '../Components/Dashboard/index.jsx';

import Store from '../Store/index.js';


class EntryPoint extends Base {
  id() {
    return 'cs:dashboard';
  }

  renderElement(element) {
    return (
      <Provider store={Store}>
        <Dashboard />
      </Provider>
    );
  }
}


export default EntryPoint;
